import React from "react";
import type { ChooseSubscriptionViewProps } from "@ps-bridge/contracts/chooseSubscription";
import * as styles from "@styles/Subscription.css";

type SelectedPackageContractProps = Pick<ChooseSubscriptionViewProps, never>;

export type SelectedPackageViewProps = SelectedPackageContractProps & {
  selectedPackage: string;
  isPayAsYouGo: boolean;
};

const SelectedPackageView: React.FC<SelectedPackageViewProps> = ({
  selectedPackage,
  isPayAsYouGo,
}) => (
  <p className={styles.selectedPackageText}>
    {isPayAsYouGo
      ? `You've selected the ${selectedPackage} package. Usage is billed directly as pages are processed, with no recurring subscription or trial-period delay.`
      : `You've selected the ${selectedPackage} package. It includes a 30-day free trial, during which you can cancel without charge.`}
  </p>
);

export default SelectedPackageView;
